// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__romvZ","edit":"styles_edit__mlyGA"};